"use strict";

export default class PersonConverter {

  static getPersonConverterFrom(person) {
    if (person === {} || person === null || person === undefined) {
      return null;
    }

    return {
      socialName: person.nome,
      cnpj: person.cnpj,
      address: {
        addressType: person.logradouro,
        number: person.numero,
        cep: person.cep,
        district: person.bairro,
        complement: person.complemento,
        city: person.municipio,
        state: person.uf,
      },

      phone: person.telefone,
      email: person.email,

      activityMain: person.atividade_principal,
      dateSituation: this.toPatternISO8601(person.data_situacao),

      secondaryEconomicActivity: person.atividades_secundarias,
      qsa: person.qsa,
      situation: person.situacao,
      openingDate: this.toPatternISO8601(person.abertura),
      legalNature: person.natureza_juridica,
      fantasyName: person.fantasia,
      lastUpdate: person.ultima_atualizacao,
      status: person.status,
      type: person.tipo,
      efr: person.efr,
      situationReason: person.motivo_situacao,
      specialSituation: person.situacao_especial,
      dateSpecialSituation: person.data_situacao_especial,
      shareCapital: person.capital_social,
      extra: person.extra,
      billing: person.billing,
      isLegalPerson: person.isLegalPerson,
      bankData: {},
      legalRepresentative: {},
      taxation: {}
    };
  } // getPersonConverterFrom()
  static toPatternISO8601(dateBr) { // de: dd/MM/yyyy para: yyyy-MM-dd
    let split = dateBr.split("/");
    return new Date(Date.parse(`${split[2]}/${split[1]}/${split[0]}`));
  }

  static toPatternBR(date) { // de: yyyy-MM-dd para: dd/MM/yyyy
    let day = "";
    let month = "";
    let year = "";

    if (!(date instanceof Date)) date = new Date();

    day = date.getDate();
    if (`${day}`.length <= 1) day = `0${day}`;

    month = date.getMonth() + 1;
    if (`${month}`.length <= 1) month = `0${month}`;

    year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

} // class



// WEBPACK FOOTER //
// ./src/utils/LegalPersonConverter.js